import { render, staticRenderFns } from "./itilLayOut.vue?vue&type=template&id=6b40f82e"
import script from "./itilLayOut.vue?vue&type=script&lang=js"
export * from "./itilLayOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports